<template>
  <el-dialog class="prints-modal" title="拼接打印设置" width="620px" :visible="visible" @close="close">
    <div class="content">
      <div class="image-example">
        <img src="@/assets/img/prints/1*1.png" alt="" />
        <img src="@/assets/img/prints/1*2.png" alt="" />
        <img src="@/assets/img/prints/2*2.png" alt="" />
      </div>
      <el-radio-group class="print-radio" v-model="printMode">
        <el-radio v-for="item in printModeList" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
      </el-radio-group>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" plain @click="close">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'printModeModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      printMode: 'ONE_LINE_ONE'
    };
  },
  computed: {
    printModeList() {
      return [
        { label: '每页打印 1张处方', value: 'ONE_LINE_ONE' },
        { label: '每页打印 2张处方', value: 'ONE_LINE_TWO' },
        { label: '每页打印 3-4张处方', value: 'TWO_LINE_TWO' }
      ];
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('confirm', this.printMode);
    }
  }
};
</script>

<style scoped lang="scss">
.content {
  display: flex;
  flex-direction: column;
  gap: 17px;
  padding: 24px 42px;

  .image-example {
    display: flex;
    gap: 45px;

    img {
      width: 150px;
    }
  }

  .print-radio {
    display: flex;
    gap: 45px;

    /deep/.el-radio {
      flex: 1;
      margin: 0;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px 24px;
  border-top: 1px solid #eee;

  /deep/.el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 16px;
    width: 60px;
  }
}
</style>
<style lang="scss">
.prints-modal {
  .el-dialog__headerbtn {
    display: block;
  }

  .el-dialog__header {
    padding: 16px 24px;
    border-bottom: 1px solid #eee;

    .el-dialog__title {
      font-size: 16px;
    }
  }

  .el-dialog__body {
    padding: unset;
  }

  .el-dialog__footer {
    padding: unset;
  }
}
</style>
